import Details from "./detail/away_detail.store";
import Entitlement from "./entitlement/away_entitlement.store";
import Assignment from "./assignment/away_assignment.store";
import Application from "./application/away_application.store";
import Individual from "./individual/away_individual.store";

export default {
  modules: { Details, Entitlement, Assignment, Application, Individual },
};
